import { observer } from "mobx-react";
import { useNavigate } from "react-router";
import AuthStore from "../../stores/AuthStore";
import { logOutIcon } from "../../assets";

export const Profile = () => {

  const navigate = useNavigate();

  const user = AuthStore.user;

  const handleLogout = () => {
    AuthStore.logout();
    navigate('/tech/login');
  }

  const text = user?.name + ' ' + user?.surname;

  const shortName = text.split(' ').map(name => name[0]).join('');

  return (
    <div className="tech-header-right-profile">
      <div className="tech-header-right-profile-icon">
        <span>{shortName.toUpperCase()}</span>
        <div className='online-status' ></div>
      </div>
      <div className="tech-header-right-profile-name">
        <span>{user.name}</span>
        <span>{user.role}</span>
      </div>
      <div className="tech-header-right-profile-chevron" onClick={handleLogout}>
        <img src={logOutIcon} alt="chevron-bottom" />
      </div>
    </div>
  );

};

export default observer(Profile);